var _slicedToArray = require("@babel/runtime/helpers/slicedToArray");
const _require = require('../../lib/evaluateSource'),
  evaluateSource = _require.evaluateSource;
/**
  * @function evalute - evaluate flangMinimumThicknessBehavior
  *
  * This is a customer behavior that is used by citgocc.
  * Eventually, would be nice to namespace it specifically
  * to that customer.
  *
  * It is a codified translation of the table of values that
  * they map together
  */
const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  // a formula without variables is valid, but not vice versa
  const size = await evaluateSource(source.size, content, parentContentPath, transientContext, nativeFunctions);
  const classVal = await evaluateSource(source.class, content, parentContentPath, transientContext, nativeFunctions);

  // this keeps two tables with tuples.
  // we iterates over the value
  const allClasses = {
    150: {
      defaultValue: 1.81,
      table: [[0.75, 0.38], [1, 0.44], [1.25, 0.5], [1.5, 0.56], [2, 0.62], [2.5, 0.69], [3, 0.81], [6, 0.88], [8, 0.94], [10, 1.06], [12, 1.12], [14, 1.19], [16, 1.31], [18, 1.38], [20, 1.5], [22, 1.62], [24, 1.75]]
    },
    300: {
      defaultValue: 2.69,
      table: [[0.75, 0.5], [1, 0.56], [1.25, 0.5], [1.5, 0.69], [2, 0.75], [2.5, 0.81], [3, 0.94], [3.5, 1.06], [4, 1.12], [5, 1.19], [6, 1.31], [8, 1.38], [10, 1.56], [12, 1.81], [14, 1.94], [16, 2.06], [18, 2.19], [20, 2.31], [22, 2.44], [24, 2.56]]
    }
  };
  let tmpClass = classVal;
  if (allClasses[tmpClass] === undefined) {
    // default to the '300' class
    tmpClass = 300;
  }
  const _allClasses$tmpClass = allClasses[tmpClass],
    defaultValue = _allClasses$tmpClass.defaultValue,
    table = _allClasses$tmpClass.table;
  if (size !== undefined) {
    for (let i = 0; i < table.length; i += 1) {
      const _table$i = _slicedToArray(table[i], 2),
        lessThan = _table$i[0],
        value = _table$i[1];
      if (size < lessThan) {
        return value;
      }
    }
  }
  return defaultValue;
};
module.exports = {
  evaluate
};